/** @format */

import React from "react";
//importing Pages
import Login from "../pages/login";
import Guarantor from "../pages/guarantor/guarantor";
import NotFound from "../pages/notFound";
import ProfileGuarantor from "../pages/guarantor/profile-guarantor";
import Dashboard from "../pages/dashboard";
import OrderHistory from "../pages/Orders/order-history";
import Drivers from "../pages/driver/drivers";
import ProfileDriver from "../pages/driver/profile-driver";
import Mangers from "../pages/manger/mangers";
import ProfileManger from "../pages/manger/profile-manger";
import MangerAccess from "../pages/manger/mangerAccess";
import ServiceStats from "../pages/service-stats/service-stats";
import ServiceDomains from "../pages/service-domains/service-domains";
import Costs from "../pages/costs/costs";
import Support from "../pages/support/support";
import OrderDetails from "../pages/Orders/OrderDetails";
import Airports from "../pages/airports/airports";
import Banners from "../pages/Banners/banners";
// eslint-disable-next-line import/no-anonymous-default-export
export default [
  { path: "/dashboard", name: "dashboard", Component: <Dashboard /> },

  { path: "/", name: "login", Component: <Login /> },
  { path: "/login", name: "login", Component: <Login /> },

  { path: "/guarantor", name: "guarantor", Component: <Guarantor /> },
  {
    path: "/guarantor/:id",
    name: "profile-guarantor",
    Component: <ProfileGuarantor />,
  },
  { path: "/history", name: "history", Component: <OrderHistory /> },
  { path: "/history/:id", name: "order-details", Component: <OrderDetails /> },
  {
    path: "/service-domains",
    name: "service-domains",
    Component: <ServiceDomains />,
  },

  { path: "/drivers", name: "drivers", Component: <Drivers /> },
  {
    path: "drivers/driver-profile/:id",
    name: "driver-profile",
    Component: <ProfileDriver />,
  },
  {
    path: "/services-stats",
    name: "services-stats",
    Component: <ServiceStats />,
  },

  { path: "/mangers", name: "mangers", Component: <Mangers /> },

  {
    path: "/mangers/:id",
    name: "profile-manger",
    Component: <ProfileManger from='general-manger' />,
  },
  // {
  //   path: "/profile-manger",
  //   name: "profile-manger",
  //   Component: <ProfileManger from='manger' />,
  // },
  {
    path: "/manger-access",
    name: "manger-access",
    Component: <MangerAccess />,
  },
  { path: "/support", name: "support", Component: <Support /> },

  { path: "/login", name: "login", Component: <Login /> },
  { path: "/costs", name: "costs", Component: <Costs /> },
  { path: "/airports", name: "airports", Component: <Airports /> },
  { path: "/banners", name: "banners", Component: <Banners /> },
  {
    path: "*",
    name: null,
    Component: <NotFound />,
  },
];
